export enum UpsertCallPlanResultType {
  Success = 'Success',
  ValidationFailed = 'ValidationFailed',
  NumbersNotUnique = 'NumbersNotUnique',
  VcareConnectorAuthenticationNotFound = 'VcareConnectorAuthenticationNotFound',
  FailedToUpsertQueue = 'FailedToUpsertQueue',
  FailedToUpdateNumbers = 'FailedToUpdateNumbers',
}

export type UpsertCallPlanResponse = {
  result: UpsertCallPlanResultType;
  numbers: string[];
};
